<template>
  <div class="register-page">
    <!-- 返回登录 -->
    <div class="back-link" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回登录</span>
    </div>
    <img
      class="login-icon"
      src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16Login1256123.png"
      alt=""
    />
    <!-- 页面标题 -->
    <h1 class="page-title">账号注册</h1>

    <!-- 注册表单卡片 -->
    <div class="form-card">
      <!-- 手机号 -->
      <div class="form-group">
        <label class="form-label">手机号</label>
        <div class="input-wrapper">
          <div class="phone-wrapper">
            <span class="country-code">+86</span>
            <input
              autocomplete="new-password"
              type="text"
              class="form-input"
              placeholder="请输入手机号"
              v-model.trim="form.phone"
              @input="handlePhoneInput"
              maxlength="11"
            />
          </div>
        </div>
      </div>

      <!-- 密码 -->
      <div class="form-group">
        <label class="form-label">密码</label>
        <div class="input-wrapper">
          <input
            autocomplete="new-password"
            :type="showPassword ? 'text' : 'password'"
            class="form-input"
            placeholder="请设置密码（至少6位数）"
            v-model.trim="form.password"
            @keydown="$utils.handleKeydownFilter"
            maxlength="20"
          />
          <img
            v-if="showPassword"
            @click="showPassword = false"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login1.png"
            alt=""
          />
          <img
            v-else
            @click="showPassword = true"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login2.png"
            alt=""
          />
        </div>
      </div>

      <!-- 确认密码 (图片中第二个密码框没有Label，紧挨着上一个) -->
      <div class="form-group no-label">
        <div class="input-wrapper">
          <input
            autocomplete="new-password"
            :type="showConfirmPassword ? 'text' : 'password'"
            class="form-input"
            placeholder="再次输入密码"
            v-model.trim="form.confirmPassword"
            @keydown="$utils.handleKeydownFilter"
            maxlength="20"
          />
          <img
            v-if="showConfirmPassword"
            @click="showConfirmPassword = false"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login1.png"
            alt=""
          />
          <img
            v-else
            @click="showConfirmPassword = true"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login2.png"
            alt=""
          />
        </div>
      </div>

      <!-- 验证码 -->
      <div class="form-group">
        <label class="form-label">验证码</label>
        <div
          class="input-wrapper code-input-wrapper"
          style="boder: none !important"
        >
          <input
            autocomplete="new-password"
            type="text"
            class="form-input code-input"
            placeholder="请输入验证码"
            v-model.trim="form.captcha"
            @keydown="$utils.handleKeydownFilter"
            maxlength="6"
          />
          <button
            class="code-btn"
            :disabled="countdown > 0 || !canGetCode"
            @click="handleGetCode"
          >
            {{ countdown > 0 ? `${countdown}秒` : "获取验证码" }}
          </button>
        </div>
      </div>

      <!-- 协议勾选 -->
      <div class="agreement-box">
        <img
          v-if="form.agree"
          @click="toggleAgreement"
          class="checkbox"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login4.png"
          alt=""
        />
        <img
          v-else
          @click="toggleAgreement"
          class="checkbox"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login5.png"
          alt=""
        />
        <span class="agreement-text">
          我已认真阅读并接受
          <a href="javascript:;" @click="goPolicy('privacy')"
            >《WONZ 隐私政策》</a
          >、
          <a href="javascript:;" @click="goPolicy('service')"
            >《WONZ服务协议》</a
          >。
        </span>
      </div>

      <!-- 注册按钮 -->
      <button class="submit-btn" :disabled="!canSubmit" @click="handleRegister">
        注册并登录
      </button>

      <!-- 底部链接 -->
      <div class="footer-links">
        <!-- <span class="link" @click="goQuickRegister">快速注册</span>
        <span class="divider">|</span> -->
        <!-- <span class="link" @click="goForgetPwd">忘记密码</span> -->
      </div>
    </div>

    <!-- 页脚 -->
    <FooterModel
      style="position: absolute; bottom: 0; left: 0; right: 0"
    ></FooterModel>
    <!--  -->
    <GoLoginPop ref="GoLoginPop"></GoLoginPop>
  </div>
</template>

<script>
import { getCode, register, checkPhone } from "@/api/index";
import GoLoginPop from "@/components/GoLoginPop.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  name: "Register",
  components: {
    FooterModel,
    GoLoginPop,
  },
  data() {
    return {
      form: {
        phone: "",
        password: "",
        confirmPassword: "",
        captcha: "",
        agree: false, // 默认不勾选，符合图片状态
      },
      showPassword: false,
      showConfirmPassword: false,
      countdown: 0,
      countdownTimer: null,
    };
  },
  computed: {
    phoneReg() {
      return /^1[3-9]\d{9}$/;
    },
    // 密码长度校验
    passwordValid() {
      return this.form.password.length >= 6 && this.form.password.length <= 20;
    },
    // 密码长度校验
    passwordValid2() {
      return (
        this.form.confirmPassword.length >= 6 &&
        this.form.confirmPassword.length <= 20
      );
    },
    // 是否可以获取验证码
    canGetCode() {
      if (!this.form.phone || this.form.phone.length !== 11) return false;
      // if (!this.phoneReg.test(this.form.phone)) return false;
      // if (!this.form.agree) return false;
      return true;
    },
    // 是否可以提交
    canSubmit() {
      if (!this.form.phone) return false;
      if (!this.form.password || this.form.password.length < 6) return false;
      if (!this.form.confirmPassword || this.form.confirmPassword.length < 6)
        return false;
      // if (this.form.password !== this.form.confirmPassword) return false;
      if (!this.form.captcha) return false;
      // if (!this.form.agree) return false;
      return true;
    },
  },
  methods: {
    goBack() {
      // this.$router.go(-1);

      this.$router.replace("/login");
    },
    handlePhoneInput(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
      this.form.phone = e.target.value;
    },
    toggleAgreement() {
      this.form.agree = !this.form.agree;
    },
    async handleGetCode() {
      // 1. 前端校验
      if (!this.form.phone) {
        this.$toast.error("请输入手机号");
        return;
      }
      if (!this.phoneReg.test(this.form.phone)) {
        this.$toast.error("请输入正确手机号");
        return;
      }
      if (!this.form.agree) {
        this.$toast.info("请先阅读并同意隐私政策及服务协议");
        return;
      }
      if (!this.form.password || !this.form.confirmPassword) {
        this.$toast.error("请先设置登录密码");
        return;
      }
      if (!this.passwordValid || !this.passwordValid2) {
        this.$toast.error("密码长度需为6-20位");
        return;
      }
      // if (this.form.password !== !this.form.confirmPassword) {
      //   this.$toast.error("两次密码不一致");
      //   return;
      // }
      try {
        let exist = true;
        await checkPhone({
          phone: this.form.phone,
        }).then((res) => {
          exist = res.exist;
        });
        if (exist) {
          this.$refs.GoLoginPop.open(2);
          return;
        }
        await getCode({
          // areaCode: "0086",
          phone: this.form.phone,
          sendType: "register",
        });
        console.log("发送验证码成功");
        this.$toast.success("验证码已发送");

        this.countdown = 60;
        this.countdownTimer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownTimer);
          }
        }, 1000);
      } catch (err) {
        this.$toast.error(err.msg);
      }
    },
    async handleRegister() {
      if (!this.form.phone) {
        this.$toast.error("请输入手机号");
        return;
      } else if (!this.phoneReg.test(this.form.phone)) {
        this.$toast.error("请输入正确手机号");
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.$toast.error("两次输入密码不一致");
        return;
      }
      if (!this.passwordValid || !this.passwordValid2) {
        this.$toast.error("密码长度需为6-20位");
        return;
      }
      if (!this.form.captcha) {
        this.$toast.error("请输入验证码");
        return;
      }
      if (!this.form.agree) {
        this.$toast.info("请先阅读并同意隐私政策及服务协议");
        return;
      }

      try {
        await register({ ...this.form }).then((res) => {
          localStorage.setItem("phone", JSON.stringify(this.form.phone));
          localStorage.setItem("token", JSON.stringify(res.token));
          this.$toast.success("注册成功");
          // setTimeout(() => {
          this.$router.replace("/");
          // }, 1000);
        });
      } catch (err) {
        if (err.msg.indexOf("用户已存在") > -1) {
          this.$refs.GoLoginPop.open(1);
        } else {
          this.$toast.error(err.msg);
        }
      }
    },
    goPolicy(type) {
      if (type === "privacy") {
        this.$router.replace("/PrivacyPolicy");
      } else {
        this.$router.replace("/UserAgreement");
      }
    },
    goQuickRegister() {
      this.$toast.info("已是注册页面");
    },
    goForgetPwd() {
      this.$router.replace("/ResetPass");
    },
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .register-page {
    position: relative;
    min-height: 100vh;
    width: 100vw;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    // padding: 3.75rem 1.25rem;
    padding-top: 3.75rem;
    box-sizing: border-box;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .back-link {
      width: 100%;
      max-width: 38rem;
      margin-bottom: 2.625rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-size: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }
    .login-icon {
      display: none;
    }
    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      margin-bottom: 3rem;
      text-align: center;
    }

    .form-card {
      width: 100%;
      max-width: 38rem;
      margin-bottom: 8rem;
      background: #fff;
      border-radius: 1.4rem;
      padding: 3.1875rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      .form-group {
        margin-bottom: 1.5rem;

        &.no-label {
          margin-top: -0.5rem; // 让第二个密码框紧挨着第一个
          margin-bottom: 1.5rem;
        }

        .form-label {
          display: block;
          font-size: 0.875rem;
          color: #333;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          height: 3.875rem;
          overflow: hidden;
          background: #fff;
          border: 1px solid #e5e5e7;
          border-radius: 0.75rem;
          transition: border-color 0.2s;

          &:focus-within {
            border-color: #0074fc;
          }

          // 手机号 +86 样式
          .phone-wrapper {
            height: 3.875rem;
            padding-left: 1rem;
            .country-code {
              color: #999;
              font-size: 1rem;
              margin-right: 0.5rem;
              border-right: 1px solid #eee;
              padding-right: 0.5rem;
              line-height: 1;
            }
            .form-input {
              border: none;
              padding-left: 0;
            }
          }

          .form-input {
            flex: 1;
            height: 100%;
            border: none;
            outline: none;
            padding: 0 1rem;
            font-size: 1rem;
            color: #101424;
            background: transparent;

            &::placeholder {
              color: #e5e5e7;
            }
          }

          .eye-icon {
            width: 1.5rem;
            height: 1.5rem;
            margin-right: 1rem;
            cursor: pointer;
            user-select: none;
          }
        }

        // 验证码输入框 wrapper
        .code-input-wrapper {
          display: flex;
          gap: 0.75rem;
          align-items: center;
          border: none;

          .code-input {
            flex: 1;
            height: 3.875rem;
            background: #fff;
            border: 1px solid #e5e5e7;
            border-radius: 0.75rem;
            padding: 0 1rem;
            font-size: 1rem;
            color: #101424;
            outline: none;
            transition: border-color 0.2s;

            &:focus {
              border-color: #0074fc;
            }

            &::placeholder {
              color: #e5e5e7;
            }
          }

          .code-btn {
            width: 8.125rem;
            height: 3.875rem;
            background-color: #1677ff;
            color: #fff;
            border: none;
            border-radius: 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            cursor: pointer;
            transition: all 0.2s;
            white-space: nowrap;

            &:disabled {
              background-color: #c4c6cc;
              cursor: not-allowed;
            }

            &:not(:disabled):hover {
              background-color: #4096ff;
            }
          }
        }
      }

      .agreement-box {
        display: flex;
        align-items: flex-start;
        margin-bottom: 2.5rem;
        margin-top: 1rem;

        .checkbox {
          width: 0.9375rem;
          height: 0.9375rem;
          margin-right: 0.5rem;
          margin-top: 0.2rem;
          cursor: pointer;
          flex-shrink: 0;
        }

        .agreement-text {
          font-size: 0.875rem;
          color: #666;
          line-height: 1.5;

          a {
            color: #0074fc;
            text-decoration: none;
          }
        }
      }

      .submit-btn {
        width: 100%;
        height: 3.875rem;
        background: #0074fc;
        border: none;
        border-radius: 0.75rem;
        color: #fff;
        font-size: 1.5rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        margin-bottom: 1.5rem;

        &:disabled {
          background: #c4c6cc;
          cursor: not-allowed;
        }

        &:not(:disabled):hover {
          background: #0066e0;
        }
      }

      .footer-links {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.875rem;
        color: #1677ff;

        .link {
          cursor: pointer;
        }

        .divider {
          margin: 0 0.75rem;
          color: #1677ff;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .register-page {
    min-height: 100vh;
    width: 100%;
    background: #ffffff;
    overflow-y: auto;
    padding: 4rem 0 16rem; /* 匹配登录页上下内边距 */
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    position: relative;

    // 返回登录链接（与登录页 .back-home 风格一致）
    .back-link {
      width: 42.375rem; /* 居中对齐，与登录页返回链接同宽 */
      margin: 0 auto 4rem; /* 下边距与登录页一致 */
      display: flex;
      align-items: center;
      color: #4e5361;
      font-weight: 600;
      font-size: 1.75rem; /* 从1rem调整为1.75rem */
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem; /* 图标从1.25rem放大到2.25rem */
        height: 2.25rem;
        margin-right: 1.1rem; /* 间距从0.5rem调整为1.1rem */
        object-fit: contain;
      }
    }
    .login-icon {
      width: 15rem;
      height: 4.25rem;
      display: block;
      margin: auto;
      margin-bottom: 1.4rem;
    }
    // 页面标题（与登录页 .login-title 一致）
    .page-title {
      font-weight: bold;
      font-size: 3rem; /* 从2rem调整为3rem */
      color: #101424;
      text-align: center;
      margin: 0 0 3rem; /* 下边距从2rem调整为3rem */
      padding: 0;
    }

    // 表单卡片（与登录页 .login-form 一致）
    .form-card {
      width: 42.375rem; /* 固定宽，居中显示 */
      margin: 0 auto;
      padding: 3rem 2.25rem; /* 上下3rem，左右2.25rem（内部元素宽37.875rem） */
      background: #ffffff;
      border-radius: 1.5rem; /* 圆角从0.75rem调整为1.5rem */
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      // 表单组（与登录页 .form-item 一致）
      .form-group {
        margin-bottom: 1.25rem; /* 从1.5rem调整为1.25rem */
        display: flex;
        flex-direction: column;
        gap: 0.5rem; /* 与登录页一致 */

        // 无label的表单组（确认密码）—— 保持负边距可能破坏布局，调整为普通margin
        &.no-label {
          margin-top: 0; /* 移除负边距，用正常间距 */
        }

        // 表单标签（与登录页 .form-label 一致）
        .form-label {
          font-size: 2rem; /* 从1.25rem调整为2rem */
          color: #1a1a1a;
          font-weight: 600;
        }

        // 输入框容器
        .input-wrapper {
          position: relative;
          width: 100%;

          // 手机号前缀
          .phone-wrapper {
            .country-code {
              position: absolute;
              left: 2rem; /* 与输入框内边距对齐 */
              top: 50%;
              transform: translateY(-50%);
              font-size: 1.75rem; /* 从1rem调整为1.75rem */
              color: #333333;
              z-index: 1;
            }

            .form-input {
              padding-left: 6rem; /* 给区号留足空间（2rem + 3字符宽度≈5rem） */
            }
          }

          // 通用输入框（与登录页 .form-input 一致）
          .form-input {
            width: 100%;
            height: 6.5rem; /* 从3.25rem调整为6.5rem */
            background: #ffffff;
            border-radius: 1.5rem; /* 从0.75rem调整为1.5rem */
            border: 1px solid #e5e5e7;
            font-size: 1.75rem; /* 从1rem调整为1.75rem */
            color: #333333;
            padding: 0 2rem; /* 从1rem调整为2rem */
            outline: none;
            box-sizing: border-box;
            transition: border-color 0.2s;

            &:focus {
              border-color: #1677ff;
            }

            &::placeholder {
              color: #c4c6cc;
            }
          }

          // 密码眼睛图标（与登录页 .password-eye 一致）
          .eye-icon {
            position: absolute;
            right: 2rem; /* 从1rem调整为2rem */
            top: 50%;
            transform: translateY(-50%);
            width: 3rem; /* 从1.5rem调整为3rem */
            height: 3rem;
            cursor: pointer;
            user-select: none;
            object-fit: contain;
          }
        }

        // 验证码输入容器（与登录页 .sms-input-wrapper 一致）
        .code-input-wrapper {
          display: flex;
          gap: 0.75rem;
          width: 100%;

          .code-input {
            border-radius: 1.5rem;
            flex: 1;
            background: #ffffff;
            border-radius: 1.5rem;
            border: 1px solid #e5e5e7;
            font-weight: 400;
            font-size: 1.75rem;
            color: #101424ff;
            text-align: left;
            padding: 0 2rem;
          }
          // 验证码按钮（与登录页 .sms-btn 一致）
          .code-btn {
            width: 12.5rem; /* 从8rem调整为12.5rem */
            height: 6.5rem; /* 从3.25rem调整为6.5rem */
            background-color: #f0f2f5;
            color: #c4c6cc;
            border: none;
            border-radius: 1.5rem; /* 从0.75rem调整为1.5rem */
            font-size: 1.75rem; /* 从1rem调整为1.75rem */
            cursor: not-allowed;
            transition: all 0.2s;
            box-sizing: border-box;

            &:not(:disabled) {
              background-color: #1677ff;
              color: #ffffff;
              cursor: pointer;
            }

            &:not(:disabled):hover {
              background-color: #4096ff;
            }
          }
        }
      }

      // 协议勾选框（与登录页 .agree-item 一致）
      .agreement-box {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
        margin: 2.1875rem 0; /* 与登录页上下边距一致（2.1875rem） */

        .checkbox {
          width: 1.5rem; /* 从1rem调整为1.5rem */
          height: 1.5rem;
          cursor: pointer;
          user-select: none;
          margin-top: 0.3rem; /* 与登录页一致 */
          object-fit: contain;
        }

        .agreement-text {
          flex: 1;
          font-size: 1.5rem; /* 从0.875rem调整为1.5rem */
          color: #666666;
          line-height: 1.4; /* 与登录页一致 */

          a {
            color: #1677ff;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      // 注册按钮（与登录页 .login-btn 一致）
      .submit-btn {
        width: 100%;
        height: 6.5rem; /* 从3.25rem调整为6.5rem */
        background-color: #c4c6cc;
        color: #ffffff;
        font-weight: 500;
        font-size: 2.25rem; /* 从1.25rem调整为2.25rem */
        text-align: center;
        border: none;
        border-radius: 1.5rem; /* 从0.75rem调整为1.5rem */
        cursor: not-allowed;
        transition: background-color 0.2s;
        box-sizing: border-box;

        &:not(:disabled) {
          background-color: #1677ff;
          cursor: pointer;
        }

        &:not(:disabled):hover {
          background-color: #4096ff;
        }
      }

      // 底部链接（与登录页 .form-links 一致）
      .footer-links {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        margin-top: 2rem; /* 从1.5rem调整为2rem */
        font-size: 1.5rem; /* 从1rem调整为1.5rem */

        .link {
          color: #1677ff;
          cursor: pointer;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        .divider {
          color: #c4c6cc;
        }
      }
    }
  }
}
</style>